import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { object, string } from 'yup';
import Book from '../Layouts/BooksForm';
import { showToast } from 'src/utils/showToaster';
import { CircularProgress } from '@mui/material';
import { BooksFormValues } from 'src/models/Books.model';
import { useGetBookByIdQuery, useUpdateBookByIdMutation } from 'src/services/BookService';

type Props = {
  onClose: () => void;
  selectedBookId: string
};

const EditBookWrapper = ({ onClose, selectedBookId }: Props) => {
  // Form Initial Values
  const [items, setItems] = useState<any>({});

  const { isLoading, isFetching, data } =
    useGetBookByIdQuery(selectedBookId);
  const [updateBookById] = useUpdateBookByIdMutation();

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setItems(data?.data);
    }
  }, [isLoading, isFetching, data]);
  const initialValues: BooksFormValues = {
    bookName: items?.bookName || ''
  };
  // Validation Schema
  const validationSchema = object().shape({
    bookName: string().required('Please enter book name'),
  });

  // Handle Submit
  const handleSubmit = (
    values: BooksFormValues,
    { setSubmitting, resetForm }: FormikHelpers<BooksFormValues>
  ) => {
    updateBookById({ id: selectedBookId, body: values }).then(
      (res: any) => {
        if (res?.error) {
          showToast("error", res?.error?.data?.message);
        } else {
          if (res?.data?.status) {
            showToast("success", res?.data?.message);
            resetForm();
            onClose();
          } else {
            showToast("error", res?.data?.message);
          }
        }
        setSubmitting(false);
      }
    );
  };


  return (
    <Dialog open maxWidth='xs' fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <Book formikProps={formikProps} onClose={onClose} formType='EDIT' />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditBookWrapper;